var Overlay = React.createClass({
  propTypes: {
    imageTimeout: React.PropTypes.number,
    showImage: React.PropTypes.bool,
    imageUrl: React.PropTypes.string,
    onClick: React.PropTypes.func,
    wrap: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      imageTimeout: 3000,
      imageUrl: `${Config.contextPath}/app/images/loading-circle.gif`,
      showImage: true,
      wrap: false
    }
  },
  getInitialState() {
    return {
      imageVisible: false
    }
  },
  componentDidMount() {
    if (this.props.showImage) {
      setTimeout(() => {
        if (this.isMounted()) this.setState({imageVisible: true})
      }, this.props.imageTimeout);
    }
  },
  overlayClicked: function() {
    if (this.props.onClick) {
      this.props.onClick();
    }
  },
  wrapOverlay(overlay) {
    return (
      <div className="overlay-wrap">{overlay}</div>
    )
  },

  render() {
    let {
      showImage,
      imageUrl,
      wrap
    } = this.props;

    let img = showImage ?
        <img src={imageUrl} className={this.state.imageVisible ? "in" : ""}/> : null;

    let overlay = (
      <div className="overlay" onClick={this.overlayClicked}>
        {img}
      </div>
    );

    return wrap ? this.wrapOverlay(overlay) : overlay;
  }
})